import { useCallback, useEffect, useState } from "react";
import { api, proofUrl, type HostQueueRow } from "../api.ts";
import { digits, rel, wa } from "../format.ts";
import { Act, Empty } from "../ui.tsx";

const DOC: Record<string, string> = { cin: "CIN", passport: "Passeport", residence_card: "Carte de séjour" };

function Entry({ e, done }: { e: HostQueueRow; done: () => void }) {
  const [reason, setReason] = useState("");
  const phone = e.user?.phone ?? null;
  return (
    <li className="card host-entry">
      <div className="kv"><b>{e.application?.displayName ?? e.user?.name}</b><span className="muted small">{e.application ? `demande ${rel(e.application.createdAt)}` : "pièce seule"}</span></div>
      <p className="small num">{e.user?.name} · {phone ? `+${digits(phone)}` : "pas de téléphone"} · {e.user?.email}</p>
      {e.application?.bio && <p className="small">{e.application.bio}</p>}
      {e.application && <p className="muted small">Langues : {e.application.languages.join(", ") || "—"}</p>}
      {phone && <div className="quick"><a className="chip" href={`tel:+${digits(phone)}`}>Appeler</a><a className="chip" href={wa(phone, `Bonjour ${e.user?.name}, c'est l'équipe Sekani au sujet de votre demande d'hôte.`) ?? "#"} target="_blank" rel="noreferrer">WhatsApp</a></div>}
      {e.documents.map((d) => (
        <div key={d.id} className="doc">
          <span className="eyebrow">{DOC[d.docType] ?? d.docType}</span>
          <div className="docimgs"><a href={proofUrl(d.frontKey)} target="_blank" rel="noreferrer"><img src={proofUrl(d.frontKey)} alt="Recto" /></a>{d.backKey && <a href={proofUrl(d.backKey)} target="_blank" rel="noreferrer"><img src={proofUrl(d.backKey)} alt="Verso" /></a>}</div>
          <div className="quick">
            <Act run={async () => { await api(`/v1/staff/id-verifications/${d.id}/approve`, { body: {} }); done(); }}>Pièce conforme</Act>
            <input placeholder="Motif du refus" value={reason} onChange={(ev) => setReason(ev.target.value)} />
            <Act tone="danger" disabled={reason.trim().length < 3} run={async () => { await api(`/v1/staff/id-verifications/${d.id}/reject`, { body: { reason: reason.trim() } }); done(); }}>Refuser</Act>
          </div>
        </div>
      ))}
      {e.application && <div className="quick"><Act run={async () => { await api(`/v1/staff/hosts/${e.userId}/approve`, { body: {} }); done(); }}>Valider l'hôte</Act></div>}
    </li>
  );
}

export function Hosts() {
  const [rows, setRows] = useState<HostQueueRow[] | null>(null);
  const load = useCallback(() => { api<HostQueueRow[]>("/v1/staff/hosts/queue").then(setRows).catch(() => setRows([])); }, []);
  useEffect(load, [load]);
  return (
    <section>
      <header className="pagehead"><h1>Propriétaires à valider</h1><p className="muted small">Appelez, vérifiez la pièce d'identité, puis validez. Un hôte non validé ne peut rien publier.</p></header>
      {rows && rows.length === 0 && <Empty>Aucune demande en attente.</Empty>}
      <ul className="rows stackc" style={{ border: 0 }}>{rows?.map((e) => <Entry key={e.userId} e={e} done={load} />)}</ul>
    </section>
  );
}
